import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { Button, Label, Input, FormGroup } from 'reactstrap';

import { getToastMsg } from '../../../ErrorMessage';

import makeUrl from '../../../../lib/makeUrl';
import { addEvent, removeEvent } from '../utils';
import { isBrowser, getNewTrekName } from '../../../../lib/utils';

import './treknameanddate.css';
import '../../../../../node_modules/flatpickr/dist/themes/airbnb.css';

import {
  patchOverviewEdits,
  updateOverviewEdits,
} from '../../../../redux/actions/overviewEditorActions';
import { closeOverviewModal } from '../../../../redux/actions/trekOverviewActions';

const ENTER_KEY = 13;

let Flatpickr = '';

if (isBrowser()) Flatpickr = require('react-flatpickr').default;

class TrekNameAndDateEditor extends Component {
  state = {
    date: moment(this.props.trekStartDate).format('YYYY-MM-DD'),
    trekName:
      this.props.renderedBy === 'use as template button'
        ? getNewTrekName(this.props.trekName, this.props.creatorName)
        : this.props.trekName,
    isSaving: false,
    showFlatPickr: false,
  };

  setTrekName = e => this.setState({ trekName: e.target.value });

  setTrekDate = val => this.setState({ date: moment(val[0]) });

  render() {
    const { isSaving, trekName } = this.state;
    const { closeOverviewModal } = this.props;

    // no spaces allowed in the trekname
    const validateTrekName = /[^\s]/.test(trekName);

    return (
      <div>
        <div className="d-mobile">
          <div className="d-flex justify-content-between border-bottom mb-3">
            <h2>SELECT NAME AND DATE FOR YOUR TREK</h2>
            <a onClick={closeOverviewModal}>
              <i className="icon icon-hg-cross" aria-hidden="true" />
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-12">
            <FormGroup>
              <Label>Trek Name</Label>
              <Input value={trekName} onChange={this.setTrekName} />
            </FormGroup>
            <p className="error">{validateTrekName ? '' : 'Trek should have a name'}</p>
          </div>
          <div className="col-sm-6 col-12">
            <FormGroup>
              <Label>Trek Start Date</Label>
              {isBrowser() && (
                <Flatpickr
                  className="form-control"
                  options={{
                    minDate: 'today',
                    dateFormat: 'Y-m-d',
                    defaultDate: [moment(this.props.trekStartDate).format('YYYY-MM-DD')],
                  }}
                  onChange={this.setTrekDate}
                />
              )}
            </FormGroup>
          </div>
          <div className="col-sm-6 col-12">
            <div className="mkt-msg">
              <h6>
                Do not worry if you do not know the exact dates right now. You can add an
                approximate date. Having approximate dates helps HoneyGuide show the
                availability of lodges, flights, flowers, and festivals more accurately. :)
              </h6>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <Button
              onClick={this.save}
              disabled={!validateTrekName}
              className={isSaving ? 'btn-loading btn-primary' : 'btn-primary'}
            >
              {isSaving ? 'Saving' : 'Save'}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  save = () => {
    let { date, trekName } = this.state;
    const {
      trekId,
      history,
      patchOverviewEdits,
      closeOverviewModal,
      updateOverviewEdits,
      trekRegion,
    } = this.props;

    this.setState({ isSaving: true, netWorkError: '' });

    const patchObj = {};
    if (!date === 'Invalid date') {
      const start_date = moment(date).format('YYYY-MM-DD');
      patchObj.start_date = start_date;
    }
    patchObj.name = trekName;

    // SEND TREKNAME AND DATE TO API
    const toastMsgData = date ? (date === 'Invalid date' ? {} : { trekDate: true }) : {};

    patchOverviewEdits(trekId, patchObj)
      .then(() => {
        // ATER SUCCESS CHANGE TREKNAME IN URL
        history.replace(`${makeUrl.trekOverview(trekName, trekId, trekRegion)}`);
        // UPDATE REDUX STORE WITH THE SAME PATCH OBJECT
        updateOverviewEdits(patchObj);
        this.setState({ isSaving: false });
        closeOverviewModal();
        getToastMsg({ type: 'changeTrekNameDate', status: 'success', data: toastMsgData });
      })
      .catch(() => {
        this.setState({ netWorkError: ' Network Error', isSaving: false });
        getToastMsg({ type: 'changeTrekNameDate', status: 'error', data: toastMsgData });
      });
  };

  onBackButtonEvent = e => this.props.closeOverviewModal();

  handleEnterPress = e => {
    if (e.keyCode === ENTER_KEY) {
      // SAVE AND CLOSE ON ENTER
      this.save();
      this.props.closeOverviewModal();
    }
  };

  componentDidMount() {
    const { history, location } = window;

    history.pushState(null, null, location.href);

    addEvent({
      elem: window,
      type: 'popstate',
      eventHandle: this.onBackButtonEvent,
      options: true,
    });

    addEvent({
      elem: window,
      type: 'keyup',
      eventHandle: this.handleEnterPress,
      options: true,
    });
  }

  componentWillUnmount() {
    removeEvent({
      element: window,
      type: 'popstate',
      eventHandle: this.onBackButtonEvent,
      options: true,
    });

    removeEvent({
      elem: window,
      type: 'keyup',
      eventHandle: this.handleEnterPress,
      options: true,
    });
  }
}

const mapStateToProps = ({ selectedTrek, user }) => ({
  trekName: selectedTrek.trek.name,
  trekId: selectedTrek.trek.id,
  trekRegion: selectedTrek.trek.region,
  trekStartDate: selectedTrek.trek.start_date,
  creatorName: user.name,
});

export default withRouter(
  connect(
    mapStateToProps,
    {
      patchOverviewEdits,
      updateOverviewEdits,
      closeOverviewModal,
    }
  )(TrekNameAndDateEditor)
);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/TrekNameAndDate/TrekNameAndDate.jsx